import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { InProduction } from "../Config";

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: "en",
    fallbackLng: "en",
    debug: !InProduction,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
